import DependenciesRemoveAllPopover from './DependenciesRemoveAllPopover';
import './DependenciesRemoveAllPopover.css';
export default DependenciesRemoveAllPopover;
